import { create } from 'zustand';

type ApplicationStore = {
  bottomNavigationHidden: boolean;
  setBottomNavigationHidden: (hidden: boolean) => void;
};

export const useApplicationStore = create<ApplicationStore>()((set) => ({
  bottomNavigationHidden: false,
  setBottomNavigationHidden: (hidden: boolean) => set(() => ({ bottomNavigationHidden: hidden })),
}));
